import { z } from 'zod'

export const customerId = z.string().min(1)
export const createCustomerInput = z.object({ name: z.string().trim().min(1).max(120) })
export type CreateCustomerInput = z.infer<typeof createCustomerInput>
export const updateCustomerInput = z
  .object({ name: z.string().trim().min(1).max(120).optional(), active: z.boolean().optional() })
  .refine((input) => Object.keys(input).length > 0, {
    message: 'Provide at least one customer field to update.'
  })
export type UpdateCustomerInput = z.infer<typeof updateCustomerInput>
export const customer = z.object({ id: customerId, name: z.string().min(1), active: z.boolean() })
export type Customer = z.infer<typeof customer>
